import { render, staticRenderFns } from "./Diagnostic.vue?vue&type=template&id=3f9e0c08"
import script from "./Diagnostic.vue?vue&type=script&lang=ts"
export * from "./Diagnostic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports